var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2786_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.14286C4.2129 1.14286 1.14286 4.2129 1.14286 8C1.14286 11.7871 4.2129 14.8571 8 14.8571C11.7871 14.8571 14.8571 11.7871 14.8571 8C14.8571 4.2129 11.7871 1.14286 8 1.14286ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.42857C8.31559 7.42857 8.57143 7.68441 8.57143 8V12C8.57143 12.3156 8.31559 12.5714 8 12.5714C7.68441 12.5714 7.42857 12.3156 7.42857 12V8C7.42857 7.68441 7.68441 7.42857 8 7.42857Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 5.14286C6.85714 4.51167 7.36882 4 8 4C8.63118 4 9.14286 4.51167 9.14286 5.14286C9.14286 5.77404 8.63118 6.28571 8 6.28571C7.36882 6.28571 6.85714 5.77404 6.85714 5.14286Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2786_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.615c3924583bdd96adcf39333178c1e6.svg";
export { ForwardRef as ReactComponent };